/**
 * A HIVAS-ABLAKBAN tarcsazando szam.
 *
 * A visszahivas a fo ablakbol indul, de a hivas mindig a kulon hivas-ablakban
 * fut (lasd huddle-window.ts): ha a fo ablak lepne be, az "Ablak" gomb egy
 * masodik belepest inditana ugyanazzal az azonositoval, ami a hivast
 * megszakitotta. Ezert a fo ablak csak felirja a szamot, megnyitja az ablakot,
 * es az ablak tarcsaz, amint bent van.
 *
 * localStorage, mert a kulon ablak (es az asztali app natív ablaka) is latja.
 * Rovid eletu: egy regen felirt, bent ragadt szam ne hivodjon fel egy kesobbi
 * hivasban. A szamot SEHOVA nem kuldjuk ki (nem kerul a cimbe sem).
 */

const KEY = 'avslack:pending-dial';
const TTL_MS = 2 * 60 * 1000;

interface PendingDial {
  channelId: string;
  number: string;
  /** Melyik vonalrol (szamrol) - hianyzik: a szerver valaszt. */
  lineId?: string;
  at: number;
}

export function setPendingDial(channelId: string, number: string, lineId?: string): void {
  try {
    const value: PendingDial = { channelId, number, at: Date.now(), ...(lineId ? { lineId } : {}) };
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // Tarolo nelkul a visszahivas nem indul magatol - a tarcsazo meg ott van.
  }
}

/**
 * Van-e friss, a csatornahoz felirt szam - NEM veszi ki.
 *
 * A hivas-ablak ebbol tudja, hogy tarcsazni nyilt: ilyenkor csendben lep be,
 * senkit nem csenget (lasd `quiet` a huddle inditasanal).
 */
export function hasPendingDial(channelId: string): boolean {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const value = JSON.parse(raw) as PendingDial;
    return value.channelId === channelId && Date.now() - value.at < TTL_MS;
  } catch {
    return false;
  }
}

/** Kiveszi (es torli) a csatornahoz felirt szamot, ha meg friss. */
export function takePendingDial(channelId: string): { number: string; lineId?: string } | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as PendingDial;
    if (value.channelId !== channelId) return null;
    localStorage.removeItem(KEY);
    if (Date.now() - value.at >= TTL_MS) return null;
    return { number: value.number, ...(value.lineId ? { lineId: value.lineId } : {}) };
  } catch {
    return null;
  }
}
